import { Stack } from '@mui/material';
import { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SessionHttpContext from '../../../../store/session-http-context';
import { Card, InlineNotification } from '../../../../components';
import styles from './HttpSessionBreakingError.module.css';

export const HttpSessionBreakingError = () => {
  const { t } = useTranslation();
  const sessionHttpContext = useContext(SessionHttpContext);

  const errorMessage = useMemo(() => {
    if (!sessionHttpContext.httpResponse?.ok && sessionHttpContext.httpResponse?.status === 401) {
      return t('page.mainError.session');
    }

    return t(`page.mainError.internal`);
  }, [sessionHttpContext.httpResponse?.ok, sessionHttpContext.httpResponse?.status, t]);

  useEffect(() => {
    const screenreaderDiv = document.querySelector('output.screenreader-text');

    if (screenreaderDiv) {
      screenreaderDiv.innerHTML = errorMessage;
    }
  }, [errorMessage]);

  return (
    <div {...{ 'data-testid': 'mainError' }}>
      <Card>
        <main className={styles.main}>
          <Stack
            className={styles.errorContainerInner}
            direction="column"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2rem'
            }}>
            <InlineNotification appearance="error">
              <span>{errorMessage}</span>

              <br></br>
            </InlineNotification>
          </Stack>
        </main>
      </Card>
    </div>
  );
};
